import { render, staticRenderFns } from "./DemoGuideButton.vue?vue&type=template&id=17061f1c&scoped=true&"
import script from "./DemoGuideButton.vue?vue&type=script&lang=js&"
export * from "./DemoGuideButton.vue?vue&type=script&lang=js&"
import style0 from "./DemoGuideButton.vue?vue&type=style&index=0&id=17061f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17061f1c",
  null
  
)

export default component.exports